<template>
  <div>
    <!-- Header -->
    <div class="row align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">Qrup əlavə et
          </h3>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <form @submit.prevent="addMessageTemplate">
        <div class="col-md-6" v-if="user.role=='Admin'">
            <label class="form-label">Partners</label>
            <select class="form-select" v-model.number="nmsgtemplate.UserId" name="specialityDropdown">
              <option></option>
              <option v-for="(partner, index) in partners" :key="index" :value="partner.id">{{ partner.partnerId }}</option>
            </select>
            <span class="inputError">{{ errors.first('specialityDropdown') }}</span>
        </div>
        <!-- Input fields -->
        <div class="row g-3 align-items-center">
          <div class="col-md-6">
            <label for="name" class="form-label">Adı</label>
            <input type="text" v-model="nmsgtemplate.Name" v-validate="{ required: true }" name="name" id="name" class="form-control" required="">
            <span class="inputError">{{ errors.first('name') }}</span>
          </div>

          <div class="col-md-6">
            <label for="PhoneNumbersFromFile" class="form-label">Fayl* əlavə edin
            </label>
            <input type="file"  name="PhoneNumbersFromFile" id="PhoneNumbersFromFile" class="form-control" @change="onFileChanged($event)">
            <span>* Fayl txt formatda olmalıdır
            </span>
            <span class="inputError">{{ errors.first('PhoneNumbersFromFile') }}</span>
          </div>

          <!-- Template text -->
          <div class="w-100 templateText">
            <label for="PhoneNumbersFromText" class="form-label">Nömrələri daxil edin
            </label>
            <br/>
            <textarea class="w-100 h-100 form-control" v-model="nmsgtemplate.PhoneNumbersFromText" name="PhoneNumbersFromText" id="PhoneNumbersFromText"></textarea>
            <span class="inputError">{{ errors.first('PhoneNumbersFromText') }}</span>
          </div>
        </div>

        <!-- Submit button -->
        <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
          Yaddaşa yaz
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'
import user from '../../../store/user'
export default {
  name: 'AddMessageTemplates',
  data() {
    return {
      loading: false,
      user: {},
      partners: [],
      nmsgtemplate: {
        Name: '',
        PhoneNumbersFromFile: '',
        PhoneNumbersFromText: '',
        UserId: 0
      },
    }
  },
  methods: {
    onFileChanged(e){
      this.nmsgtemplate.PhoneNumbersFromFile = e.target.files[0];
    },
    async addMessageTemplate() {
      this.loading = true
      
      const validForm = await this.isFormValid()
      if (validForm) {
        jwtInterceptor.post(this.$store.getters.getUrl + "/SmsGroups", this.nmsgtemplate, { headers:{'Content-Type': 'multipart/form-data'}}).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("Group uğurla əlavə olundu!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch((response) => {
          let errorText = ''
          // if (response.response.data.error === 'message_template_of_this_type_for_this_clinic_already_exists')
          //   errorText = 'Bu klinika üçün bu tip şablon artıq vardır!'
          // else
            errorText = 'Bir xəta baş verdi.'
          
          this.$toast.error(errorText, {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
      this.loading = false
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
    getPartners() {
      jwtInterceptor.get(this.$store.getters.getUrl+'/Users')
      .then( response => {
        this.partners = response.data.result.items;
      })
    },
  },
  created() {
    this.user = user.getters.getUser
    if(this.user.role == 'Admin')
      this.getPartners();
    else {
      this.nmsgtemplate.UserId = this.user.id
    }
  }
}
</script>

<style>
.templateText {
  height: 150px;
  margin-bottom: 2rem;
}

.justify-content-custom {
  justify-content: space-between;
}

@media screen and (max-width: 615px) {
  .justify-content-custom {
    justify-content: space-around !important;
  }
}
</style>